export default __webpack_public_path__ + "static/media/gsapBW.e1b7edd7.webp";